import React from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import SVG from 'react-inlinesvg';
import lsLogoHorizontal from '@lifesize/ux-assets/vectors/svgLogos/lsHorizontalTM.svg';
import lsLogoBuddy from '@lifesize/ux-assets/vectors/svgLogos/lsBuddyTM.svg';
import helpIcon from '@lifesize/ux-assets/vectors/svgIcons/help-outline.svg';
import ButtonComp from 'components/Button/Button';
import lsConfig from 'utils/global-config';
import classes from './Retry.module.scss';

const messages = defineMessages({
  tryAgain: { id: 'components.retryComponent.tryAgain', defaultMessage: 'Try Again' },
  hasCheckInFailure: { id: 'components.retryComponent.hasCheckInFailure',
    defaultMessage: 'Please contact your system administrator.' }
});

const retryMessage = ({ hasCheckInFailure, noRetry, intl }) => {
  if (hasCheckInFailure) {
    return (
      <FormattedMessage
        id="components.retryComponent.hasCheckInFailure"
        defaultMessage="Please contact your system administrator."
      />
    );
  }
  if (noRetry) {
    return (
      <FormattedMessage
        id="components.retryComponent.internet.check"
        defaultMessage="Please check your internet connection."
      />
    );
  }

  return (
    <FormattedMessage
      id="components.retryComponent.internet"
      defaultMessage="Please check your internet connection, then click {tryAgain}."
      values={{
        tryAgain: <b>{intl.formatMessage(messages.tryAgain)}</b>
      }}
    />
  );
};

const Retry = props =>
  (
    <div className={classes.retryContainer}>
      <div className={classes.headerContainer}>
        <SVG src={lsLogoHorizontal} className={classes.logo} data-testid="lsLogoHorizontal" />
        <SVG src={helpIcon} className={classes.icon} data-testid="helpIcon" />
      </div>
      <div className={classes.mainContent}>
        <SVG src={lsLogoBuddy} className={classes.buddyIcon} data-testid="lsLogoBuddy" />
        <div className={classes.content}>
          <h3>
            <FormattedMessage
              id="components.retryComponent.title"
              defaultMessage="Unable to Connect"
            />
          </h3>
          <div>
            <FormattedMessage
              id="components.retryComponent.connect"
              defaultMessage="We were not able to connect to the Lifesize service."
            />
          </div>
          <div className={classes.internet}>
            {retryMessage(props)}
          </div>
          {(!props.noRetry && !props.hasCheckInFailure) &&
            <ButtonComp
              kind={'primary'}
              style={{ height: 50 }}
              onClick={() => {
                lsConfig.skipOnBeforeUnload();
                window.location.reload(true);
              }}
            >
              <FormattedMessage
                {...messages.tryAgain}
              />
            </ButtonComp>
          }
        </div>
      </div>
      <div className={classes.footerContainer}>
        <FormattedMessage
          id="components.retryComponent.footerMessage"
          defaultMessage="Lifesize audio, web, and video conferencing... we've got your meetings covered. Try it free at {link}."
          values={{
            link: <a href="http://www.lifesize.com">lifesize.com</a>
          }}
        />
      </div>
    </div>
  );

Retry.propTypes = {
  noRetry: PT.bool,
  hasCheckInFailure: PT.bool,
  intl: PT.object
};

retryMessage.propTypes = {
  noRetry: PT.bool,
  hasCheckInFailure: PT.bool,
  intl: PT.object
};

Retry.defaultProps = {
  noRetry: false,
  hasCheckInFailure: false
};

export default injectIntl(Retry);
